<template>
  <div class="pt-3 px-3 mb-3 light-gray-container" :class="panelOptions.color">
    <TitleBreadCrumb
      :has-route="false"
      :page="{
        icon: panelOptions.titleIcon || 'fas fa-clipboard-list-check',
        title: panelOptions.title,
      }"
    />

    <ValidationObserver ref="form" tag="div" class="row px-4 pb-4">
      <div class="col-12 pt-2">
        <ValidationProvider
          v-slot="{ errors, validate }"
          mode="lazy"
          rules="required"
          :custom-messages="{
            required: `Favor escriba ${textAreaLabelLower}.`,
          }"
        >
          <CustomTextArea
            v-model="model.comment"
            :disabled="panelOptions.readonly"
            :label="`${textAreaLabel}:`"
            regular-label
            :maxlength="3000"
            :show-char-count="!panelOptions.readonly"
            :count-classes="['d-block text-right']"
            :error="errors[0]"
            :custom-error-msg="errors[0]"
            @input="validate"
          />
        </ValidationProvider>
      </div>

      <div v-if="!panelOptions.readonly" class="col-12 mt-3 text-right">
        <ActionButton
          class="m-1"
          text="Cancelar"
          variant="outline-danger"
          i="fas fa-times-circle"
          @click="onCancel"
        />
        <ActionButton
          class="m-1"
          text="Continuar"
          variant="success"
          i="fas fa-arrow-alt-circle-right"
          @click="onContinue"
        />
      </div>

      <div v-else class="col-12 pt-3">
        <div class="color-secondary-6 font-14">{{ userLabel }}:</div>
        <div class="color-black font-16">
          {{ panelOptions.user }}
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import CustomTextArea from 'CustomTextArea';
import ActionButton from 'ActionButton';
import TitleBreadCrumb from 'TitleBreadCrumb';
import alert from '@/mixin/alert.mixin';

const initialModel = () => ({ comment: null });

export default {
  name: 'StatusChangePanel',
  mixins: [alert],
  components: {
    CustomTextArea,
    ActionButton,
    TitleBreadCrumb,
  },
  props: {
    panelOptions: { type: Object, default: () => ({}) },
  },
  data: () => ({ model: initialModel() }),
  computed: {
    textAreaLabel() {
      return this.panelOptions.color === 'danger' ? 'Razón' : 'Comentario';
    },
    textAreaLabelLower() {
      return this.textAreaLabel.toLowerCase();
    },
    userLabel() {
      return this.panelOptions.color === 'danger'
        ? 'Devuelto por'
        : 'Aprobado por';
    },
  },
  methods: {
    async onContinue() {
      if (this.panelOptions.readonly) return;
      const valid = await this.$refs['form'].validate();
      if (valid) {
        this.$emit('continue', this.model.comment);
      } else {
        this.ShowToast(
          'Información Incompleta',
          'Favor de completar la información solicitada.',
          'error'
        );
      }
    },
    onCancel() {
      this.model = initialModel();
      this.$refs['form'].reset();
      this.$emit('cancel');
    },
  },
  mounted() {
    this.model.comment = this.panelOptions.defaultComment;
  },
};
</script>

<style lang="scss" scoped>
@use "sass:map";
@import '@/assets/scss/variables/_colors.scss';
.light-gray-container {
  background: map.get($colors, 'secondary-3');
  border-radius: 5px;
  box-shadow: 0px 3px 6px #00000029;
}
.light-gray-container.danger {
  border-left: 4px solid map.get($colors, 'primary-4');
}
.light-gray-container.success {
  border-left: 4px solid map.get($colors, 'green');
}

.light-gray-container ::v-deep .orange-icon-badge-align {
  font-size: 1.125rem !important;
  color: map.get($colors, 'primary-4') !important;
}
.light-gray-container.danger ::v-deep .orange-icon-badge-align {
  color: map.get($colors, 'primary-4') !important;
}
.light-gray-container.success ::v-deep .orange-icon-badge-align {
  color: map.get($colors, 'green') !important;
}

::v-deep .dot {
  padding: 4px !important;
}

::v-deep .tag-badge {
  background: none !important;
}

::v-deep .tag-badge-title {
  font-size: 1.125rem !important;
  color: map.get($colors, 'gray-7') !important;
}
</style>
